import React, { useEffect } from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HomeOutlined, LoginOutlined } from "@ant-design/icons";
import locale from "@aligov/global-locale";
import { useAuth } from "../../contexts/AuthContext";
import { navigateToLogin } from "../../utils/navigation";

// 语言标映射
const langMap = {
  "zh-CN": "zh",
  "en-US": "en",
  "th-TH": "th",
};

const Forbidden: React.FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { logout, clearAuthData, setIsAuthenticated } = useAuth();

  useEffect(() => {
    const { lang } = locale.getLocale();

    if (lang) {
      i18n.changeLanguage(langMap[lang] || lang);
    }
  }, []);

  const handleBackHome = () => {
    navigate("/");
  };

  const handleLogout = () => {
    logout();

    navigateToLogin(false, "/");
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f5f5",
      }}
    >
      <Result
        status="403"
        title={t("forbidden.title")}
        subTitle={t("forbidden.subtitle")}
        extra={[
          // <Button
          //   key="home"
          //   icon={<HomeOutlined />}
          //   onClick={handleBackHome}
          // >
          //   {t('forbidden.backHome')}
          // </Button>,
          <Button
            key="login"
            type="primary"
            icon={<LoginOutlined />}
            onClick={handleLogout}
          >
            {t("forbidden.reLogin")}
          </Button>,
        ]}
      />
    </div>
  );
};

export default Forbidden;
